module.exports = "<gw-change-payment-source-form ng-if=\"havedata\"\r\nchange-action=\"changePaymentAction(instrument)\"\r\ninvoice-stream=\"info\"\r\ncancel-action=\"cancelAction()\"\r\ngo-back=\"goBack()\"\r\nremove-action=\"removePaymentAction()\">\r\n</gw-change-payment-source-form>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/billing/views/setup-change-payment.html
// module id = 555
// module chunks = 0